<template>

	<div class="popup-wrapper">
		<div class="popup-label" @click="popupOpen = !popupOpen">
			<div class="popup-closed" v-if="!popupOpen"><span class="questionmark">?</span><span class="hexagon">&#x2B22;</span></div>
			<div class="popup-open" v-if="popupOpen">
				Need Some Help?
				<i class="fa fa-chevron-down"></i>
			</div>
		</div>
		<div class="popup-content" v-if="popupOpen">
			<div class="help-header">Help Articles</div>
			<ul>
				<li v-for="(value, name) in helpLink"><a :href="'/dashboard/help-center/articles/' + name" target="_blank">{{ value }}</a></li>
			</ul>
			<br>
			
			<div v-if="tours" class="help-button-section">
				<div class="button action help-button" @click="startTour()">Start Walkthrough</div>
			</div>
		</div>
	</div>
</template>

<!--  -->
<!--  -->
<!-- How to use this component ... 
		~ import HelpPopup from '@/components/HelpPopup.vue'
		~ components: { 'help-popup': HelpPopup }

		ADD TO THE END OF THE COMPONENT/VUE HTML:
		~ <help-popup :helpLink="{Article Number:'Article Name', etc}" :tour="false"></help-popup>
			IF THERE IS ALSO A WALKTHROUGH TUTORIAL CHANGE :tour="true"
			AND ADD <v-tour name="myTour" :steps="steps"></v-tour> BELOW
		
		TO ADD WALKTHROUGH STEPS:
		~ add to data return: https://github.com/pulsardev/vue-tour/wiki/Getting-Started
			steps: [
				{
					target: '[data-v-step="0"]',
					content: "Step Content.",
					params: { highlight: true }
				},
				{
					steps etc...
				}
			]
		~ <div data-v-step="0" goes around the target elements
		-->	
<!--  -->
<!--  -->


<script>
export default {
	name: 'help-popup',
	props: ['helpLink','tours'],
	data() {
		return {
			popupOpen: false,
		}
	},
	methods: {
		startTour() {
			this.$tours["myTour"].start();
			this.popupOpen = false
		}
	}
}
</script>

<style lang="scss" scoped>
	.popup-wrapper {
		position: absolute;
		top: -2.75em;
		right: 0;
		// border-radius: 6px 6px 0 0;
		// border: 2px solid #0d7ea0;
		filter: drop-shadow(1px -1px 4px #d2d2d2);
		z-index: 1000;
		.popup-label {
			font-size: 1.25em;
			color: white;
			font-weight: bold;
			width: 100%;
			display: inline-block;
			cursor: pointer;
			i {
				float: right;
			}
			.popup-closed {
				text-align: center;
				width: 3em;
   				height: 3em;
				padding: 0.25em 0.5em;
				.questionmark {
					z-index: 2;
					position: relative;
				}
				.hexagon {
					color: #0d7ea0;
					font-size: 3em;
					position: absolute;
					left: 0; right: 0; top: 0;
					line-height: 0.4em;
					z-index: 0;
					transform: rotate(0) translate(0px, 0px);
					animation-name: wiggle;
  					animation-duration: 20s;
					animation-delay: 6s;
					animation-iteration-count: 3;
					animation-timing-function: ease-out;
					
				}
				@keyframes wiggle {
					0% {transform: rotate(0);}
					2% {transform: rotate(23deg) translate(2px, 0px);}
					4% {transform: rotate(0);}
					100% {transform: rotate(0);}
				}
			}
			.popup-open {
				background-color: #0d7ea0;
				padding: 0.25em 0.5em;
				width: 100%;
				font-size: 1em;
			}
		}

		.popup-content {
			background-color: white;
			padding: 1em;
			width: 15em;
			.help-header {
				font-size: 1.25em;
				font-weight: bold;
				padding: 5px 0 15px 0;
			}
			ul {
				list-style: initial;
				li {
					padding: 0.25em 0;
					font-weight: 600;
					a { color: #003b4d; }
				}
				li:hover {
					a { color: #0d7ea0; }
				}
			}
			.help-button {
				background-color: #003b4d !important;
			}
		}
	}
</style>